import { useFocus } from '@/store/hooks/focus';
import { bounds } from 'leaflet';
import React from 'react';
import { useMap } from 'react-leaflet';
import { MapMarker } from '.';

export interface FocusMarkerHandlerProps {
  markers: MapMarker[];
}

const FocusMarkerHandler: React.FunctionComponent<FocusMarkerHandlerProps> = ({
  markers,
}) => {
  const map = useMap();
  const { focus } = useFocus();
  React.useEffect(() => {
    if (focus || focus === 0) {
      map.flyTo(markers[focus].position, 11);
    }
  }, [focus]);
  React.useEffect(() => {
    if (markers && markers.length && markers.length > 1) {
      const bounds = markers.map(({ position }) => position);
      const allSamePositions =
        bounds.filter(
          (bound) => bound[0] !== bounds[0][0] && bound[0] !== bounds[0][0],
        ).length === 0;
      if (!allSamePositions) {
        // Bounds will crash if they all are the same lat/lng
        map.flyToBounds(bounds);
      } else {
        map.flyTo(bounds[0]);
      }
    }
  }, [markers]);
  return null;
};
export default FocusMarkerHandler;
